import Session from "@lib/session";
import useContent from "@lib/use_content";
import userProfileDeletePud from "@services/user_profile_delete_pud";
import { useState } from "react";

export default function useLocationRemoval() {
  const { data: contentData } = useContent([
    "beErrProfileLocationsDelete",
    "beProfileLocationsDeleteSuccess",
  ]);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function removeLocation(id: string, onSuccess: () => void): Promise<void> {
    setErrorMessage("");
    setSuccess("");

    setSubmitting(true);

    const success = await userProfileDeletePud(
      parseInt(id),
    );

    if (!success) {
      setErrorMessage(contentData?.content.beErrProfileLocationsDelete || "");
    } else {
      onSuccess();
      setSuccess(contentData?.content.beProfileLocationsDeleteSuccess || "");
    }

    setSubmitting(false);
  }

  async function clearSuccessAndEdit() {
    setSuccess("");
    setErrorMessage("");
  }

  return { removeLocation, errorMessage, success, submitting, clearSuccessAndEdit };
}
